define('services/unit-converter',[
    'underscore', 'quantities', 'utils',
    // 'env',
], function(_, Qty, U) {

    var UnitConverter = {
        convert: function(value, fromUnit, toUnit, round) {
            round = round || true;

            var convertedValue = new Qty(Number(value), fromUnit).to(toUnit).scalar;

            if (round)
                convertedValue = Math.round(convertedValue * 100) / 100;
            
            return convertedValue;
        },
    };

    return UnitConverter;
});

